// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"b8884947","453":"7060c98d"}[chunkId] + ".chunk.js";
};